import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { sortByOrder } from "../helpers";
import api from "../providers/api";

const initialState = {
  strategies: [],
  isLoading: true,
};

export const getSubObjectives = createAsyncThunk("get-objectives", async () => {
  const response = await api.strategy.getAllWithSubObjectives();

  return response.Data.map((item) => {
    return {
      ...item,
      Perspectives: item.Perspectives.map((e) => {
        return {
          ...e,
          StrategicObjectives: e.StrategicObjectives.map((so) => {
            return {
              ...so,
              StrategicSubObjective: sortByOrder(so.StrategicSubObjective),
            };
          }),
        };
      }),
    };
  });
});

const subObjectiveSlice = createSlice({
  name: "subObjectives",
  initialState,
  reducers: {
    updateSubObjective: (state, { payload }) => {
      if (state.strategies?.length === 0) return;

      const _strategies = state.strategies.map((item) => {
        return {
          ...item,
          Perspectives: item.Perspectives.map((e) => {
            return {
              ...e,
              StrategicObjectives: e.StrategicObjectives.map((el) => {
                return {
                  ...el,
                  StrategicSubObjective: el.StrategicSubObjective.filter(
                    (obj) => {
                      return obj.ID !== payload.ID;
                    }
                  ),
                };
              }),
            };
          }),
        };
      });

      const strategyIndex = _strategies.findIndex(
        ({ ID }) => ID === payload.StrategicObjective.Perspective.Strategy.ID
      );

      const perspectiveIndex = _strategies[
        strategyIndex
      ].Perspectives.findIndex(
        (e) => e.ID === payload.StrategicObjective.Perspective.ID
      );

      const strategicObjectiveIndex = _strategies[strategyIndex].Perspectives[
        perspectiveIndex
      ].StrategicObjectives.findIndex(
        (e) => e.ID === payload.StrategicObjective.ID
      );

      _strategies[strategyIndex].Perspectives[
        perspectiveIndex
      ].StrategicObjectives[strategicObjectiveIndex].StrategicSubObjective.push(
        payload
      );

      _strategies[strategyIndex].Perspectives[
        perspectiveIndex
      ].StrategicObjectives[strategicObjectiveIndex].StrategicSubObjective =
        sortByOrder(
          _strategies[strategyIndex].Perspectives[perspectiveIndex]
            .StrategicObjectives[strategicObjectiveIndex].StrategicSubObjective
        );

      state.strategies = _strategies;
    },
    deleteSubObjective: (
      state,
      { payload: { strategyIndex, perspectiveIndex, objectiveIndex, id } }
    ) => {
      const itemIndex = state.strategies[strategyIndex].Perspectives[
        perspectiveIndex
      ].StrategicObjectives[objectiveIndex].StrategicSubObjective.findIndex(
        (so) => so.ID === id
      );

      if (itemIndex !== -1) {
        state.strategies[strategyIndex].Perspectives[
          perspectiveIndex
        ].StrategicObjectives[objectiveIndex].StrategicSubObjective.splice(
          itemIndex,
          1
        );
      }
    },
  },
  extraReducers: {
    [getSubObjectives.fulfilled]: (state, action) => {
      state.strategies = action.payload;
      state.isLoading = false;
    },
    [getSubObjectives.pending]: (state) => {
      state.isLoading = true;
    },
    [getSubObjectives.rejected]: (state) => {
      state.isLoading = false;
    },
  },
});

export const { updateSubObjective, deleteSubObjective } =
  subObjectiveSlice.actions;

export default subObjectiveSlice.reducer;
